module.exports = __webpack_public_path__ + "img/entete.aec33ccf.png";